import React from 'react';
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";

function TitleDivider({text, textStyle, ...props}) {
  return (
    <Stack marginTop={0} marginBottom='3px' {...props} >
      <Stack direction='row' gap={0.25} justifyContent='left'>
        <Typography
          variant='largeBoldLoose'
          color='text.primary'
          padding='7.5px 7.5px 3px 0'
          letterSpacing='1.2px'
          display='block'
          sx={textStyle}
        >
          {text}
        </Typography>
        {
          props?.Icon ? <props.Icon color='primary'/> : null
        }
      </Stack>
      <Divider />
    </Stack>
  );
}

export default TitleDivider;